import _ from "lodash";

import {
	SERVICE_REMOVED,
	SERVICES_LOADED,
	SERVICES_UPDATED,
	SERVICES_DASHBOARD_LOADING,
	SERVICE_CATEGORIES_LOADED,
	SERVICE_CATEGORIES_LOADING,
	NEWS_PURGE,
} from "../actions/types";

const INITIAL_STATE = {
	services: [],
	submissions: [],
	loading: false,
	submissionsLoading: false,
	serviceCategories: [],
	serviceCategoriesLoading: false,
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SERVICES_DASHBOARD_LOADING:
			return {
				...state,
				loading: true,
			};
		// case NEWS_SUBMISSIONS_DASHBOARD_LOADING:
		//     return {
		//         ...state,
		//         submissionsLoading: true
		//     };
		case SERVICE_REMOVED:
			const indexF = _.findIndex(state.services, (event) => {
				return event != null && event.RowId === action.payload;
			});
			if (indexF > -1) {
				const newEventsF = [...state.services];
				newEventsF.splice(indexF, 1);
				return { ...state, services: newEventsF };
			}
			return state;
		case SERVICES_LOADED:
			var resultn = _.filter(action.payload, (ev) => {
				return !ev.Deleted;
			});
			return {
				...state,
				services: resultn,
				loading: false,
			};
		case SERVICES_UPDATED:
			var result = _.unionWith(action.payload, state.services, (v1, v2) => {
				return v1 != null && v2 != null && v1.RowId === v2.RowId;
			});
			result = _.filter(result, (ev) => {
				return !ev.Deleted;
			});
			return {
				...state,
				services: result,
				loading: false,
			};
		case SERVICE_CATEGORIES_LOADING:
			return {
				...state,
				serviceCategoriesLoading: true,
			};
		case SERVICE_CATEGORIES_LOADED:
			return {
				...state,
				serviceCategories: action.payload,
				serviceCategoriesLoading: false,
			};
		case NEWS_PURGE:
			return INITIAL_STATE;
		default:
			return state;
	}
};
